import type { ModeratorContractCreateUpdateRequest } from "../services/moderators/generated/model";

// Mirrors ModeratorContractCreateUpdateSerializer.status choices on the
// backend. Hard-coded here rather than imported as the generator gives the
// inline-enum a hash-suffixed name (Status88fEnum) we don't want to depend on.
export type ContractStatus = "draft" | "active" | "completed" | "cancelled";

export interface ContractFormState {
  contractType: string;
  contractValue: string;
  status: ContractStatus;
  startDate: string;
  endDate: string;
  dateSigned: string;
  description: string;
  termsAndConditions: string;
  documents: string;
}

export const emptyContractForm: ContractFormState = {
  contractType: "Partnership",
  contractValue: "",
  status: "draft",
  startDate: "",
  endDate: "",
  dateSigned: "",
  description: "",
  termsAndConditions: "",
  documents: "",
};

/**
 * Body for `deals/<id>/contract/save`. On create, empty inputs are left out.
 * On edit, an input the moderator emptied is sent as null / "" / [] so the
 * backend clears it — leaving it out would keep the old value.
 */
export function buildContractPayload(form: ContractFormState, isEdit: boolean): ModeratorContractCreateUpdateRequest {
  const payload: ModeratorContractCreateUpdateRequest = {
    contractType: form.contractType.trim(),
    status: form.status,
  };
  const nullable = (value: string): string | null | undefined => value || (isEdit ? null : undefined);
  const text = (value: string): string | undefined => value || (isEdit ? "" : undefined);
  const docs = form.documents
    .split("\n")
    .map((s) => s.trim())
    .filter(Boolean);

  const fields: Partial<ModeratorContractCreateUpdateRequest> = {
    contractValue: nullable(form.contractValue),
    dateSigned: nullable(form.dateSigned),
    startDate: nullable(form.startDate),
    endDate: nullable(form.endDate),
    description: text(form.description),
    termsAndConditions: text(form.termsAndConditions),
    documents: docs.length || isEdit ? docs : undefined,
  };
  for (const [key, value] of Object.entries(fields)) {
    if (value !== undefined) (payload as unknown as Record<string, unknown>)[key] = value;
  }
  return payload;
}
